/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2026 Pearson Education, Inc. All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Pearson Education, Inc. The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

/**
 * Invite service
 *
 * @file InviteService.js
 * @author Mohamed Yasar Arabath M
 */


import Framework, { BaseService } from '@greenville/framework';
import {
  INVITE_SERVICE_REQUESTED,
  INVITE_SERVICE_FETCHED,
  INVITE_SERVICE_FAILED
} from '../../../common/constants';

export default class InviteService extends BaseService {
  constructor() {
    super(INVITE_SERVICE_REQUESTED);
  }

  fetch(courseId) {
    return this.getClient('marin').get(`/courses/${courseId}/invite-link`);
  }

  /**
   * Handles book collection service event
   *
   * @param {*} eventName
   * @param {*} eventData
   * @returns
   */
  handleEvent(eventName, eventData) {
    const { courseId } = eventData;

    return this.getClient('marin').get(`courses/${courseId}/invite-link`);
  }

  // eslint-disable-next-line class-methods-use-this
  handleResponse({ data }) {
    Framework.getEventManager().publish(INVITE_SERVICE_FETCHED, data);
  }

  // eslint-disable-next-line class-methods-use-this
  handleError(error) {
    Framework.getEventManager().publish(INVITE_SERVICE_FAILED, error);
  }
}
